// ###########################################
// My Independent Self-Hosted Editor Component
// ###########################################

// import React from 'react';
import React, { useRef } from 'react';

// const { Editor } = React.lazy(() => import('@tinymce/tinymce-react'));
    // // Подгружаем модули редактора (Self-Hosted)
    // import '../../tinymce/tinymce';
    // import '../../tinymce/icons/default';
    // import '../../tinymce/themes/silver';
    // import '../../tinymce/models/dom/model';
    // //  import '../../tinymce/plugins/paste';
    // // Подгружаем плагины редактора (Self-Hosted)
    // import '../../tinymce/plugins/autolink';
    // import '../../tinymce/plugins/fullscreen';
    // import '../../tinymce/plugins/image';
    // import '../../tinymce/plugins/link';
    // import '../../tinymce/plugins/lists';
    // import '../../tinymce/plugins/wordcount';
    // import '../../tinymce/plugins/code';
        // import './_tinymce/skins/ui/oxide/skin.min.css';
        // import './_tinymce/skins/ui/oxide/content.min.css';
        // import './_tinymce/skins/content/default/content.min.css';
        // import 'tinymce/skins/ui/oxide/content.inline.min.css'
    //         // import contentUiCss from '../../tinymce/skins/ui/oxide/content.min.css';
    //         // import contentCss from '../../tinymce/skins/ui/oxide/content.min.css';
    // Мой стиль редактора (скин)
    import './skin.css';
    // Стиль отвечающий за подсветку "Заполните это поле"
    import './alarm.css';
    // Мой стиль контента (в окне редактора)
    // import { tinyContentCss } from '../../../data/globals'
// Обертка для реакта
import { Editor } from '@tinymce/tinymce-react';


const MyEditor = (props) => {
    const editorRef = useRef(null); // для tinyMCE

    return (
        <div className="mt-4 w540">
            <Editor
                tinymceScriptSrc={ './tiny-independ-self-hosted/tinymce/tinymce.min.js' } // Self Hosted в ./public folder
                // tinymceScriptSrc={ 'https://api-catalog/mytinymce/tinymce/tinymce.min.js' }
                onInit={(evt, editor) => editorRef.current = editor}
                {...props}

                init={{
                    // width: 540,
                    height: 240,
                    menubar: false,
                    toolbar_mode: 'wrap',
                    image_advtab: true,
                    draggable_modal: true, // разрешить перетаскивание окна image
                    // content_style: "* { font-family: Roboto, 'Helvetica Neue', Arial, sans-serif; color: #198754;} ",
                    // content_css : tinyContentCss,
                    // content_css : "https://api-catalog/test-tinymce/bootstrap.css",
                    // content_css : './content.css', // Self Hosted в ./public folder
                    skin: false,
                    // content_css: false,
                    // content_css: 'https://Vue-React.github.io/test/tiny-independ-self-hosted/content.min.css',
                    // content_css_cors: true,
                    content_css: './tiny-independ-self-hosted/content.css',
                    // content_css: './components/UI/content.css',
                    // content_css: './content.css',
                    // skin_url: './tiny-self-hosted/skin.min.css', // путь к скину
                    // skin_url: './skin.css', // путь к скину
                    plugins: 'autolink fullscreen image link lists wordcount code', //  quickbars - контекстное меню
                    toolbar: 'bold italic underline | forecolor bullist | link image code fullscreen',
                }}
            />
        </div>
    )
}

export default MyEditor;